import { Form, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Cards } from '../../components/cards/frame/cards-frame'
import { Main } from '../styled'
import config from '../../config/config';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Modal, notification, Button } from 'antd';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { ProjectHeader } from '../project/style';
import { PageHeader } from '../../components/page-headers/page-headers';
import CreateSEO from './CreateSEO';
import EditMeta from './EditMeta';

function ManageSEO() {

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [getSEOData, setSEOnata] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [seoId, setId] = useState(null);

  const [deliverystatus, setDeliveryStatus] = useState("");

  const [editData, setEditData] = useState(null);


  const UID = useSelector((state) => {
    return state.fb.auth.uid;
  });

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setId(null)
    setEditData(null)
    setIsEditModalVisible(false);
    setIsModalVisible(false);
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const deleteSEO = (id) => {
    Modal.confirm({
      title: 'Delete Blog',
      content: (
        <div>
          <p>Do you want to delete SEO</p>
        </div>
      ),
      onOk() {


        const data = { id };

        axios.post(`${config.apiUrl}/delete-seo`, data)
          .then(function (response) {
            notification.success({
              message: "The SEO deleted successfully"
          });
            getAllSEO();
          })
          .catch(function (error) {
            return false;
          });

      },
      onCancel() { }
    });

  }
  const openSEOModal = (id, data) => {
        
    setEditData(data)
    setId(id)
    setIsEditModalVisible(true);
  };



  const history = useHistory();

  useEffect(() => {

    sessionStorage.removeItem('tab-index');
    var temp_data = [];    

    getAllSEO();


  }, [])

  const getAllSEO = async () => {
    const response = await fetch(`${config.apiUrl}/get-all-seo/null`, {
      method: "GET", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
      }
    });
    const data = await response.json();    
    setSEOnata(data)
  }

  


  const handleStatus = async () => {
    let BrowserData = { id: orderId, delivery_status: deliverystatus, order_id: txn_id }
    console.log(JSON.stringify(BrowserData));
    axios.post(`${config.apiUrl}/update-order-status`, BrowserData)
      .then(function (response) {
        if (response.status && response.status == 200) {
          sessionStorage.setItem("update_status", "1")
          location.reload();
        }

      })
      .catch(function (error) {
        console.log(error);
      });

  }



  let columns = [    
    {
      title: 'Page Name',
      dataIndex: 'page_name',
    },
    {
      title: 'Page URL',
      dataIndex: 'page_url'
    },
    {
      title: 'Meta Title',
      dataIndex: 'page_meta_title'
    },
    {
      title: 'Meta Description',
      dataIndex: 'page_meta_description'
    },
    {
      title: 'Meta Robot',
      dataIndex: 'page_meta_robot'
    },
    
    {
      title: 'Edit',
      dataIndex: ['seo_id'],
      //render: (id, row) => <span onClick={() => { showImageModal(), imageDetailsGet(row['id']) }} style={{ cursor: 'pointer', wordBreak: 'break-word' }}>{row['work_title'] != null && row['work_title'] != "" && row['work_title'].slice(0, 70)} {row['work_title'] != null && row['work_title'] != "" && row['work_title'].length > 70 && "..."}</span>
      render: (id, row) => {
        return (
          <EditOutlined onClick={() => { openSEOModal(row['seo_id'], row) }} />
        )
      }
    },
    {
      title: 'Delete',
      dataIndex: ['seo_id'],
      render: (id, row) => {
          return (
            <DeleteOutlined onClick={() => { deleteSEO(row['seo_id']) }} />
          )
      }
    }
  ];

  return (
    <>

      <ProjectHeader >
        <PageHeader
          ghost
          title="Manage SEO Page"
          buttons={[
            <Button onClick={openModal} type="primary" size="large">Create SEO </Button>
          ]}
        />
      </ProjectHeader>

      <Main className='main-layout-div'>
        <Cards>
          <div className="table-responsive">
            <Table dataSource={getSEOData} columns={columns} />
          </div>
        </Cards>

        <CreateSEO onCancel={handleCancel} visible={isModalVisible} />
        
        {seoId != null && editData !=null && <EditMeta onCancel={handleCancel} visible={isEditModalVisible} Id={seoId} editData={editData} />} 
      </Main>
    </>
  )
}

export default ManageSEO
